import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { StyledRadio } from '../../../../../utils/designComponents/StyledRadio';
import RadioGroup from '@material-ui/core/RadioGroup';
import {observer} from "mobx-react-lite";
import {useWebsocketStore} from "../../../../../stores/websocketStore/websocketProvider";

const smallFont = { fontSize: 15 };
const AccountNumberSelect = observer(({dataSource, brokerage, accountNumber, setAccountNumber}) => {
  const {accountBalanceStore} = useWebsocketStore();
  const balances = accountBalanceStore.balances;
  let accounts = [];
  if (
      dataSource === 'LIVE' &&
      brokerage !== 'BACKTEST'
  ) {
    if (balances !== undefined) {
      for (let accountId in balances) {
        if (accountId === 'BACKTEST') {
          continue;
        }
        let account = {
          accountId: accountId,
          nickname: balances[accountId].nickname,
        };
        accounts.push(account);
      }
    }
  } else {
    accounts.push({ accountId: 'BACKTEST', nickname: 'SIM' });
  }

  return (
      <BuildSelect
          accounts={accounts}
          accountNumber={accountNumber}
          setAccountNumber={setAccountNumber}
      />
  );
});
export default AccountNumberSelect;
/*

export default class AccountNumberSelect1 extends React.Component {
  constructor(props) {
    super(props);
    this.observable = BalancesObservable;
    this.state = { balances: {} };
  }

  componentDidMount() {
    this.subscription = this.observable.subscribe((value) =>
      this.setState({ balances: value })
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  render() {
    let accounts = [];
    if (
      this.props.dataSource === 'LIVE' &&
      this.props.brokerage !== 'BACKTEST'
    ) {
      if (this.state.balances !== undefined) {
        for (let accountId in this.state.balances) {
          if (accountId == 'BACKTEST') {
            continue;
          }
          let account = {
            accountId: accountId,
            nickname: this.state.balances[accountId].nickname,
          };
          accounts.push(account);
        }
      }
    } else {
      accounts.push({ accountId: 'BACKTEST', nickname: 'SIM' });
    }

    return (
      <BuildSelect
        accounts={accounts}
        accountNumber={this.props.accountNumber}
        setAccountNumber={this.props.setAccountNumber}
      />
    );
  }
}
*/

function BuildSelect({ accounts, accountNumber, setAccountNumber }) {
  return (
    <>
      <RadioGroup
        row
        aria-label="accountNumber"
        name="accountNumber"
        value={accountNumber}
        onChange={(ev) => {
          setAccountNumber(ev.target.value);
        }}
      >
        <Grid container>
          <Grid item xs={4}>
            <FormLabel>
              <Typography style={smallFont}>account:</Typography>
            </FormLabel>
          </Grid>
          {accounts.map((account) => (
            <Grid item xs={4} key={account.accountId}>
              <FormControlLabel
                key={account.accountId}
                value={account.accountId}
                control={<StyledRadio />}
                label={
                  <Typography style={smallFont}>{account.nickname}</Typography>
                }
              />
            </Grid>
          ))}
        </Grid>
      </RadioGroup>
    </>
  );
}
